import React from 'react';
import { makeStyles } from '@material-ui/core';
import { SRC } from './logsConstants';

const SRC_LABELS = {
  Validator: 'Validator',
  Runtime: 'Runtime',
  Simulation: 'Simulation',
};

const useStyles = makeStyles(() => ({
  pill: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '2px 7px',
    borderRadius: 4, // small rounded corners — a "square" pill, not a full capsule
    fontSize: 10.5,
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '.03em',
    lineHeight: 1.4,
    whiteSpace: 'nowrap',
  },
}));

export default function SourcePill({ src }) {
  const classes = useStyles();
  const meta = SRC[src === "Validator" ? "Blueprint Validator" : src];
  
  if (!meta) return null;
  return (
    <span className={classes.pill} style={{ backgroundColor: meta.bg, color: meta.color }}>
      {SRC_LABELS[src] || src}
    </span>
  );
}